module.exports = __webpack_public_path__ + "img/layout_right_2.cf804418.png";